import config from "@/config"
import http from "@/utils/request"

export default {
	decorate:{
        url: `${config.API_URL}/bwmall/admin.decorate/lists`,
		name: "获取装修信息",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
    decorateAdd:{
        url: `${config.API_URL}/bwmall/admin.decorate/add`,
		name: "添加装修信息",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
	setMemberValues:{
		url: `${config.API_URL}/manage/member/config/setMemberValues`,
		name: "修改配置信息",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	// 新UI专用配置保存接口（按租户member_id隔离，需传tab_name）
	setMemberValuesNew:{
		url: `${config.API_URL}/manage/member/config/setMemberValuesNew`,
		name: "修改配置信息(新UI)",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	userSetting:{
		url: `${config.API_URL}/manage/member_login/userSetting`,
		name: "个人信息",
		get: async function(data={}){
			return await http.get(this.url, data);
		},
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},
	message:{
		url: `${config.API_URL}/manage/member/message/list`,
		name: "站内信",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	messageRead:{
		url: `${config.API_URL}/manage/member/message/read`,
		name: "读站内信",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	// ==================== 租户账户相关（与租户后台 managesaas 同源接口） ====================

	/**
	 * 修改当前登录账号密码
	 * 参数: { id, mobile, password2, password }
	 * 返回: errcode==0 表示修改成功
	 */
	userPassword:{
		url: `${config.API_URL}/manage/member/login/userPassword`,
		name: "修改密码",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	},

	/**
	 * 操作日志列表（用户中心-操作日志表格数据源）
	 * 参数: { page: 页码, limit: 每页条数 }（mnTable 自动追加分页参数）
	 */
	syslog:{
		url: `${config.API_URL}/manage/member_sys_log/index`,
		name: "操作日志列表",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	}
}
